var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-about"},[_c('about-header',{attrs:{"about":_vm.headerItem}}),_c('about-e-class',{attrs:{"item":_vm.eClassItem,"id":"aboutEClass"}}),_c('about-connect-us',{attrs:{"item":_vm.connectItem}}),_c('about-map',{attrs:{"item":_vm.mapItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }